import React, { FC } from "react";
import { SettingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import FormInput from "../../pages/form-components/InputComponent";

interface SequenceInputProps {
  name?: string;
  label: string;
  numberingMode: "auto" | "manual";
  onSettingsClick: () => void;
  showSettingsIcon?: boolean;
  maxLength?: number;
  pattern?: RegExp;
  placeholder?: string;
}

/**
 * Document-number input that flips between auto and manual numbering.
 *
 * - auto:   field disabled, shows "Auto-generated" (server assigns the number).
 * - manual: field editable + required (user enters the number).
 *
 * A settings gear opens the SequenceConfigModal to switch modes.
 */
const SequenceInput: FC<SequenceInputProps> = ({
  name = "referenceID",
  label,
  numberingMode,
  onSettingsClick,
  showSettingsIcon = true,
  maxLength = 20,
  pattern = /^[a-zA-Z0-9./_-]+$/,
  placeholder,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <FormInput
        name={name}
        label={label}
        required={numberingMode === "manual"}
        type="text"
        pattern={pattern}
        maxLength={maxLength}
        disabled={numberingMode === "auto"}
        placeholder={
          placeholder ||
          (numberingMode === "auto" ? "Auto-generated" : `Enter ${label}`)
        }
      />
      {showSettingsIcon && (
        <Tooltip
          title={`Click here to enable or disable auto-generation of ${label} numbers.`}
        >
          <SettingOutlined
            style={{
              position: "absolute",
              right: "10px",
              // Anchor to the bottom (which lines up with the input's bottom)
              // so the icon stays centered on the input regardless of the
              // label height, which differs between the drawer and the
              // compact stepper page.
              bottom: "18px",
              transform: "translateY(50%)",
              cursor: "pointer",
              fontSize: "18px",
              color: "#2557d6",
              zIndex: 1,
            }}
            onClick={onSettingsClick}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default SequenceInput;
